import React from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
} from '@material-ui/core'

const DialogConfirm = ({
  title,
  description,
  confirmText,
  open,
  setOpen = () => {},
  handleConfirm = () => {},
  loading = false,
}) => {
  return (
    <Dialog open={open} onClose={loading ? () => {} : () => setOpen(false)}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">{title}</Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box py={1}>
          <Typography>{description}</Typography>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions p={2}>
        <Box pl={2} pr={1}>
          <Button
            type="button"
            variant="outlined"
            onClick={loading ? () => {} : () => setOpen(false)}
            disabled={loading}
          >
            Cancelar
          </Button>
        </Box>
        <Button
          variant="contained"
          type="submit"
          color="primary"
          onClick={handleConfirm}
          disabled={loading}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogConfirm
